import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Clock } from 'lucide-react';
const adventures = [{
  title: 'Moonlight Over Pilis',
  group: 'Ridgeline Rovers',
  date: 'Oct 14, 2026',
  time: '19:00',
  location: 'Dobogókő',
  price: '4,500 HUF',
  image: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Autumn Foliage Walk',
  group: 'Wanderkin Collective',
  date: 'Oct 17, 2026',
  time: '09:30',
  location: 'Normafa',
  price: '2,500 HUF',
  image: 'https://images.unsplash.com/photo-1507041957456-9c397ce39c97?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: "The Stone Giant's Path",
  group: 'Trailmark Fellowship',
  date: 'Oct 24, 2026',
  time: '07:00',
  location: 'Börzsöny',
  price: '6,000 HUF',
  image: 'https://images.unsplash.com/photo-1465188162913-8fb5709d6d57?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
export function UpcomingAdventures() {
  return <section id="upcoming" className="py-24 bg-earth-100" data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-112">
          <div data-id="element-113">
            <span className="text-sunset-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-114">
              Calendar
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-forest-900" data-id="element-115">
              Upcoming Adventures
            </h2>
          </div>
          <button className="text-forest-800 font-medium hover:text-sunset-600 transition-colors duration-300 flex items-center gap-2 group" data-id="element-116">
            View Full Calendar
            <span className="group-hover:translate-x-1 transition-transform duration-300" data-id="element-117">
              →
            </span>
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-118">
          {adventures.map((adventure, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.6
        }} className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300" data-id="element-119">
              <div className="relative h-64 overflow-hidden" data-id="element-120">
                <img src={adventure.image} alt={adventure.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-121" />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-1 rounded-full text-sm font-bold text-forest-900 shadow-sm" data-id="element-122">
                  {adventure.price}
                </div>
                <div className="absolute bottom-4 left-4 bg-forest-900/90 backdrop-blur-sm px-3 py-1 rounded-md text-xs font-medium text-white uppercase tracking-wide" data-id="element-123">
                  {adventure.group}
                </div>
              </div>

              <div className="p-6" data-id="element-124">
                <h3 className="text-2xl font-serif font-bold text-forest-900 mb-4 group-hover:text-sunset-600 transition-colors" data-id="element-125">
                  {adventure.title}
                </h3>

                <div className="space-y-3 text-stone-600" data-id="element-126">
                  <div className="flex items-center gap-3" data-id="element-127">
                    <Calendar className="w-5 h-5 text-earth-600" data-id="element-128" />
                    <span data-id="element-129">{adventure.date}</span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-130">
                    <Clock className="w-5 h-5 text-earth-600" data-id="element-131" />
                    <span data-id="element-132">{adventure.time}</span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-133">
                    <MapPin className="w-5 h-5 text-earth-600" data-id="element-134" />
                    <span data-id="element-135">{adventure.location}</span>
                  </div>
                </div>

                <button className="w-full mt-8 border border-forest-900 text-forest-900 py-3 rounded-lg font-medium hover:bg-forest-900 hover:text-white transition-colors duration-300" data-id="element-136">
                  Reserve Spot
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}